/**
 * Composable che gestisce l'utente corrente considerando l'impersonazione
 * Durante l'impersonazione restituisce l'utente impersonato, altrimenti l'utente della sessione
 */
export const useCurrentUser = () => {
  const { user: sessionUser } = useUserSession()
  const { isImpersonating, targetUser } = useImpersonation()

  const user = computed(() => {
    return isImpersonating.value ? targetUser.value : sessionUser.value
  })

  return { user }
}
